import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { useCart } from "../context/CartContext";   // 🛍️ global cart context
import Navbar from "./DashBoard/Navbar";
import Footer from "./DashBoard/Footer";





const ProductDetail = () => {
  const { id } = useParams();
  const [product, setProduct] = useState(null);
  const [mainImage, setMainImage] = useState("");
  const [pincode, setPincode] = useState("");

  const { addToCart } = useCart();   // ✅ access context function
  const navigate = useNavigate();    // ✅ for redirect

  useEffect(() => {
    axios
      .get(`https://hrgf.salepatner.com/api/products/${id}/`)
      .then((res) => {
        setProduct(res.data);
        setMainImage(res.data.image);
      })
      .catch((err) => console.error("Error fetching product:", err));
  }, [id]);

  if (!product) return <div className="text-center mt-10">Loading...</div>;

  const allImages = product.images?.length ? product.images : [product.image];

  
  //handle  add to cart
  const handleAddToCart = () => {
  if (!product) return;

  const cartItem = {
    id: product.id,
    title: product.title,
    price: product.price,
    image: product.image,
  };

  addToCart(cartItem);         // ✅ add to global cart
  navigate("/cart");        // uncomment this line if you want redirect
};


// ⭐ Buy Now → redirect to checkout
const handleBuyNow = () => {
  navigate("/checkout");
};



  return (

    <>
    <Navbar />
    <div className="bg-gray-50 pt-0 pb-0 mt-0">

      <div className="max-w-7xl mx-auto flex flex-col md:flex-row gap-6 bg-white p-0 m-0 shadow-none border-none">


        
        {/* 🔹 LEFT SIDE STICKY IMAGE SECTION */}
<div className="md:w-2/5 relative mt-0 pt-0">

  <div className="sticky top-20 flex flex-col items-center gap-6">
    {/* Image Section */}
    <div className="flex gap-3 w-full items-start">

      {/* Thumbnail list */}
      <div className="flex md:flex-col gap-2 overflow-x-auto md:overflow-y-auto">
        {allImages.map((img, index) => (
          <img
            key={index}
            src={img}
            alt={`thumb-${index}`}
            className={`w-16 h-16 object-cover rounded-md border cursor-pointer ${
              mainImage === img ? "border-blue-600" : "border-gray-300"
            }`}
            onClick={() => setMainImage(img)}
          />
        ))}
      </div>

      {/* Main Image */}
      <div className="flex-1 border rounded-lg bg-gray-100 p-3 flex justify-center items-center">
        <img
          src={mainImage}
          alt={product.title}
          className="object-contain w-full max-h-[550px]"
        />
      </div>
    </div>

    {/* 🔸 Sticky Buttons just below image */}
    <div className="flex gap-4 w-full justify-center sticky bottom-4 bg-white py-3 shadow-md rounded-lg z-10">
  <button
    onClick={handleAddToCart}
    className="bg-orange-500 hover:bg-orange-600 text-white font-semibold 
               px-5 py-3 rounded-lg text-base flex items-center justify-center 
               gap-2 w-[38%]"
  >
    🛒 Add to Cart
  </button>

  <button
    className="bg-yellow-500 hover:bg-yellow-600 text-white font-semibold 
               px-5 py-3 rounded-lg text-base flex items-center justify-center 
               gap-2 w-[38%]"
  >
    ⚡ Buy Now
  </button>
</div>

  </div>
</div>


        {/* 🔹 Right Side Scrollable Detail Section */}
        <div className="flex-1 mt-[6px]">


          {/* Title + Rating */}
          <h1 className="text-xl font-medium text-gray-600 leading-snug">{product.title}</h1>

          <div className="flex items-center mt-2 text-sm text-gray-600">
            <span className="bg-green-600 text-white px-2 py-0.5 rounded text-xs mr-2">
              {product.rating.toFixed(1)} ★
            </span>
            <span>{product.rating_count} Ratings & {product.review_count} Reviews</span>
          </div>

          {/* Price */}
          <div className="flex items-baseline gap-2 mt-4">
            <h2 className="text-3xl font-bold text-gray-800">₹{product.price}</h2>
            {product.discount_price && (
              <>
                <span className="text-gray-400 line-through text-lg">
                  ₹{product.discount_price}
                </span>
                <span className="text-green-600 font-semibold">20% off</span>
              </>
            )}
          </div>

          <p className="text-sm text-gray-600 mt-1">
            + ₹149 Protect Promise Fee | Free Delivery
          </p>

          {/* Offers */}
          <div className="mt-6 border-t pt-4">
            <h3 className="text-lg font-semibold mb-2">Available Offers</h3>
            <ul className="text-sm text-gray-700 space-y-1">
              <li>💳 Bank Offer: 5% cashback on Axis Bank Cards</li>
              <li>💰 No Cost EMI from ₹6,659/month</li>
              <li>🚚 Free Delivery by 8 Nov</li>
              <li>🔄 7 Days Replacement Policy</li>
            </ul>
          </div>

          {/* Buy without/with Exchange */}
          <div className="mt-6 border rounded-md">
            <div className="flex justify-between items-center px-4 py-3 border-b">
              <div className="flex items-center gap-2">
                <input type="radio" defaultChecked />
                <span className="text-sm font-medium text-gray-800">
                  Buy without Exchange
                </span>
              </div>
              <span className="font-semibold text-gray-900">₹{product.price}</span>
            </div>
            <div className="flex justify-between items-center px-4 py-3">
              <div className="flex items-center gap-2">
                <input type="radio" />
                <span className="text-sm font-medium text-gray-800">
                  Buy with Exchange
                </span>
              </div>
              <span className="text-sm text-gray-600">up to ₹47,300 off</span>
            </div>
            <div className="px-4 pb-3 text-red-600 text-sm">
              Enter pincode to check if exchange is available
            </div>
          </div>

          {/* Delivery */}
          <div className="mt-6 border-t pt-4">
            <h4 className="font-semibold text-sm mb-2">Delivery</h4>
            <div className="flex items-center gap-2">
              <input
                type="text"
                placeholder="Enter Pincode"
                value={pincode}
                onChange={(e) => setPincode(e.target.value)}
                className="border px-3 py-2 rounded-lg text-sm w-40 focus:ring-2 focus:ring-blue-500"
              />
              <button className="text-blue-600 font-semibold text-sm">Check</button>
            </div>
            <p className="text-xs mt-1 text-gray-500">
              Delivery by <b>8 Nov, Saturday</b> | Installation by 11 Nov | ₹399
            </p>
          </div>

          {/* Highlights */}
          <div className="mt-6 border-t pt-4">
            <h4 className="font-semibold text-sm mb-2">Highlights</h4>
            <ul className="list-disc list-inside text-sm text-gray-700 space-y-1">
              {product.highlights?.split(",").map((item, i) => (
                <li key={i}>{item.trim()}</li>
              ))}
            </ul>
          </div>

          {/* Seller */}
          <div className="mt-6 border-t pt-4">
            <h4 className="font-semibold text-sm mb-2">Seller</h4>
            <p className="text-sm text-gray-700">
              <b>{product.seller}</b>{" "}
              <span className="bg-blue-100 text-blue-800 px-2 py-0.5 rounded text-xs ml-1">
                {product.rating.toFixed(1)} ★
              </span>
            </p>
            <p className="text-xs text-gray-500">
              7 Days Brand Support | GST Invoice Available
            </p>
          </div>

          {/* Easy Payment */}
          <div className="mt-6 border-t pt-4">
            <h4 className="font-semibold text-sm mb-2">Easy Payment Options</h4>
            <ul className="list-disc list-inside text-sm text-gray-700 space-y-1">
              <li>No cost EMI starting from ₹6,659/month</li>
              <li>Cash on Delivery</li>
              <li>Net banking & Credit/Debit/ATM Card</li>
            </ul>
          </div>

          {/* Description */}
          <div className="mt-8 border-t pt-4">
            <h3 className="text-lg font-semibold mb-2">Description</h3>
            <p className="text-sm text-gray-700 leading-relaxed">
              {product.description}
            </p>
          </div>

          {/* Specifications (Other Details) */}
          <div className="mt-8 border-t pt-4">
            <h3 className="text-lg font-semibold mb-3">Specifications</h3>
            <h4 className="font-medium mb-2 text-gray-800">Other Details</h4>
            <div className="grid grid-cols-2 text-sm text-gray-700 gap-y-2">
              {Object.entries(product.specifications || {}).map(([key, value]) => (
                <p key={key}>
                  <b>{key}:</b> {value}
                </p>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </>
  );
};

export default ProductDetail;
